import { GetServerSideProps, NextPage } from 'next';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useMatchMedia } from '@alfalab/core-components/mq';
import config from 'config';
import { trackInAnalytics } from 'newclick-alfa-metrics';

import { BasicLayout } from '@components/BasicLayout';
import { ButtonGoToApp } from '@components/ButtonGoToApp';
import { CardInputForm } from '@components/CardInputForm';
import { InfoForTransfer } from '@components/InfoForTransfer';
import { router } from '@utils/router';
import { RootState } from '@utils/types';

interface Props {
    userAgent?: string;
    appVersion?: string;
}

const IndexPage: NextPage<Props> = ({ appVersion }) => {
    const [mobile] = useMatchMedia('--mobile');
    const form = useRef(null);
    const { publicId }: any = useSelector((state: RootState) => state.settings.query);
    const { loading, success, failure, result } = useSelector((state: RootState) => state.request.transferRequest);

    const sendTo3ds = () => {
        form.current.submit();
    };

    useEffect(() => {
        if (!loading && success && !failure && result) {
            if (Object.keys(result).length === 0) {
                router.internalRedirect('/error');
            } else {
                sendTo3ds();
            }
        } else if (!loading && failure) {
            router.internalRedirect('/error');
        }
    }, [loading, success, failure, result]);

    useEffect(() => {
        trackInAnalytics('SHOW_PAGE', { screen: 'Main' });
    }, []);

    const page = (
        <BasicLayout showHeader={true}>
            <InfoForTransfer />
            {mobile ? <ButtonGoToApp appVersion={appVersion} /> : null}
            <CardInputForm />
            {result && (
                <form ref={form} action={result.acsURL} method='post' className='hidden'>
                    <input type='hidden' name='PaReq' value={result.PaReq} />
                    <input
                        type='hidden'
                        name='TermUrl'
                        value={`https://${config.get('client.redirectHost')}${config.get(
                            'client.contextRoot'
                        )}/result?id=${publicId}&transactionId=${result.transactionId}`}
                    />
                    <input type='hidden' name='MD' value={result.MD} />
                </form>
            )}
        </BasicLayout>
    );

    return page;
};

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) => {
    const headerUseAgent = req.headers['user-agent'];
    const headerAppVersion = req.headers['app-version'] as string;

    const userAgent = headerUseAgent || config.get('server.userAgent');
    const appVersion = headerAppVersion || config.get('server.appVersion');

    return {
        props: {
            userAgent,
            appVersion
        }
    };
};

export default IndexPage;
